module.exports = __webpack_public_path__ + "static/media/publicsonar_mobility_selected.d265d7c9.svg";